import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import { tracked } from '@glimmer/tracking';
import { next } from '@ember/runloop';

var _class, _descriptor;
let Revision = (_class = class Revision {
  constructor() {
    _initializerDefineProperty(this, "value", _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "value", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _class);
const revision = new Revision();
let bumpScheduled = false;
function bumpRevision() {
  if (bumpScheduled) return;
  bumpScheduled = true;
  next(() => {
    bumpScheduled = false;
    revision.value++;
  });
}
const checks = new WeakMap();

/**
 * @param {object} record the record a modal passes as @item
 * @param {() => boolean} fn true ONLY when nothing the user can lose changed
 * @returns {() => void} unregister (removes only this fn)
 */
function registerPristineCheck(record, fn) {
  if (!record || typeof record !== 'object' && typeof record !== 'function' || typeof fn !== 'function') {
    return () => {};
  }
  checks.set(record, fn);
  return () => {
    if (checks.get(record) === fn) {
      checks.delete(record);
    }
  };
}

/**
 * @param {object} record
 * @returns {boolean} true only when a registered check says «pristine»
 */
function isRegisteredPristine(record) {
  if (!record || typeof record !== 'object' && typeof record !== 'function') return false;
  const fn = checks.get(record);
  if (typeof fn !== 'function') return false;
  try {
    return fn() === true;
  } catch {
    return false;
  }
}
const dirtyChecks = new WeakMap();

/**
 * @param {object} record the record a modal passes as @item
 * @param {{ isDirty: () => boolean, discard?: () => void }} check isDirty true when an edit
 *   the record's own hasDirtyAttributes does not see would be lost; discard rolls it back
 * @returns {() => void} unregister (removes only this check)
 */
function registerDirtyCheck(record, check) {
  if (!record || typeof record !== 'object' && typeof record !== 'function' || typeof check?.isDirty !== 'function') {
    return () => {};
  }
  dirtyChecks.set(record, check);
  bumpRevision();
  return () => {
    if (dirtyChecks.get(record) === check) {
      dirtyChecks.delete(record);
      bumpRevision();
    }
  };
}

/**
 * @param {object} record
 * @returns {boolean} true when a registered check reports unsaved edits (a throwing check
 *   counts as dirty: asking once too often never loses data)
 */
function isRegisteredDirty(record) {
  // consumed so a render reader re-evaluates when a check is (un)registered after it rendered
  revision.value;
  if (!record || typeof record !== 'object' && typeof record !== 'function') return false;
  const check = dirtyChecks.get(record);
  if (typeof check?.isDirty !== 'function') return false;
  try {
    return check.isDirty() === true;
  } catch {
    return true;
  }
}

/** «Close without saving»: roll back what the registered check tracks (no-op without one). */
function discardRegistered(record) {
  if (!record || typeof record !== 'object' && typeof record !== 'function') return;
  const check = dirtyChecks.get(record);
  if (typeof check?.discard !== 'function') return;
  try {
    check.discard();
  } catch {
    // the record's own rollback still runs in the caller
  }
}

/**
 * The record has edits the user would lose: the SAME answer BbModal gives before it asks «Sono presenti modifiche non
 * salvate» (components/bb-modal.js close guard) — the record's own hasDirtyAttributes, or a registered dirty check for an
 * existing record, unless a registered pristine check clears a NEW record. A destroyed / destroying record has nothing
 * to save (and reading it can throw): false.
 * @param {object} record
 * @returns {boolean}
 */
function hasUnsavedEdits(record) {
  if (!record || typeof record !== 'object' && typeof record !== 'function') return false;
  if (record.isDestroyed || record.isDestroying) return false;
  const isNew = Boolean(record.isNew);
  const dirty = Boolean(record.hasDirtyAttributes) || !isNew && isRegisteredDirty(record);
  return dirty && !(isNew && isRegisteredPristine(record));
}

export { discardRegistered, hasUnsavedEdits, isRegisteredDirty, isRegisteredPristine, registerDirtyCheck, registerPristineCheck };
//# sourceMappingURL=pristine-registry.js.map
